import React from "react";
import Main from "../../../../components/main";
import A from "../../../../components/a";
import ghastScreen from "./assets/ghastscreen.png";
// import redMobileBg from "./assets/red-bg-mobile.png";
import hype from "./assets/hype.png";
import "./styles.css";

const HowItWorks = () => (
  <div
    className="howitworks"
    id="howitworks"
    // style={{
    //   background: `linear-gradient(135deg, #f15a4e, #d24452), url(${redMobileBg})`
    // }}
  >
    <Main>
      <div className="wrap">
        <img
          className="ghast-screens"
          src={ghastScreen}
          alt="ghast screenshot"
        />
        <A href="/images" className="imageslink">
          View all images
        </A>
        <div>
          <h2>How it works?</h2>
          <p>
            Ghast works by modifying your computer's network settings based what
            latency you decide, to come up with the best settings for you. The
            results are great and it gives you a nice edge in pvp! We also make
            a point to never touch or interfere with Minecraft in any way, and
            to never limit your network connection. It also works on 1.7.10,
            1.8, 1.7.10 mods, 1.8 forge mods, lounge client, lunar client,
            badlion client, or any other minecraft version!
          </p>
          <img className="safe-points" src={hype} alt="shield" />
        </div>
      </div>
    </Main>
  </div>
);

export default HowItWorks;



/** WEBPACK FOOTER **
 ** ./src/views/pages/home/sections/howItWorks/index.js
 **/